@if (activity) {
    <ng-container>
        <ng-template [ngTemplateOutlet]="activityTemplate" [ngTemplateOutletContext]="{}"></ng-template>
    </ng-container>

    <ng-template #activityTemplate>
        @if (activity) {
            <ng-container [ngTemplateOutlet]="activity.templateRef"></ng-container>
        }
    </ng-template>
}
